import type { RouteObject } from 'react-router';

import { lazy, Suspense } from 'react';

import { DocumentTitle } from 'src/routes/components';

import { SplashScreen } from 'src/components/loading-screen/splash-screen';

// ----------------------------------------------------------------------

const ItemNotFoundPage = lazy(() => import('src/pages/error/item-not-found'));

const itemNotFoundElement = (
  <Suspense fallback={<SplashScreen />}>
    <>
      <DocumentTitle titleOverride="Item not found" />
      <ItemNotFoundPage />
    </>
  </Suspense>
);

export function getErrorRoutes(): RouteObject[] {
  return [
    {
      path: 'error',
      children: [{ path: 'item-not-found', element: itemNotFoundElement }],
    },
  ];
}
